import React, { useEffect, useRef, useState } from "react";

import { DetectarTela } from "../../utils/detectarTamanhoTela";
import { color } from "../../utils/colors";

import "../../utils/font-roboto.scss";
import "./index.scss";

const Container = ({
  altura,
  titulo,
  children,
  img_fundo,
  fundoEscuro,
  id_container,
  sobreTomImagem,
  containerSemPadding,
  tamanhoPensonalizado,
}) => {
  const tituloRef = useRef(null);
  const [tituloHeight, setTituloHeight] = useState(0);

  let tamanhoTitulo = DetectarTela();

  useEffect(() => {
    if (tituloRef.current) {
      setTituloHeight(tituloRef.current.offsetHeight);
    }
  }, [tamanhoTitulo]);

  return (
    <div
      id={id_container}
      className="montagem-container"
      style={
        fundoEscuro && {
          backgroundColor: color?.escuro,
        }
      }
    >
      <div
        className="container"
        style={{
          height: altura ? altura : "100%",
          backgroundImage: `${img_fundo && `url(${img_fundo})`}`,
        }}
      >
        {titulo && (
          <div
            ref={tituloRef}
            className="titulo-container"
            style={{
              color: color?.branco,
            }}
          >
            <div
              className="titulo bold px64"
              style={{ backgroundColor: color?.barra }}
            >
              {titulo}
            </div>
          </div>
        )}
        <div
          className="fundo"
          style={
            sobreTomImagem
              ? {
                  background:
                    "linear-gradient(to bottom,rgba(0, 0, 0, 0.9),rgba(0, 0, 0, 0.65) 5%,rgba(0, 0, 0, 0.65) 95%,rgba(0, 0, 0, 1))",
                  backdropFilter: "blur(3px)",
                }
              : {
                  backgroundColor: "transparent",
                }
          }
        >
          {children && (
            <div
              className={`children`}
              style={
                titulo && {
                  paddingTop: `${
                    !containerSemPadding ? `${tituloHeight}px` : "0"
                  } `,
                  width: tamanhoPensonalizado ? "100%" : "90%",
                }
              }
            >
              {children}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Container;
